import React from "react";
import PortfolioInfo from "./PortfolioInfo";
import Testimonial from "./Testimonial";

const Portfolio = () => {
  return (
    <div>
      <PortfolioInfo />
      <Testimonial />
    </div>
  );
};

export default Portfolio;
